import React from 'react';
import { Modal, Button } from 'react-bootstrap';

/**
 * Placeholder: Situação do Cliente — demanda futura.
 * Equivalente ao RxDBGrid2DblClick → TFConsultaSituacao (fora de escopo W-0488, P3 PRD).
 */
const ModalSituacaoClienteStub = ({ aberto, codigoConta, codigoGrupoEmpresa, onFechar }) => {
  return (
    <Modal show={aberto} onHide={onFechar} size="sm" centered>
      <Modal.Header style={{ background: '#0747a6', color: '#fff' }}>
        <Modal.Title style={{ fontSize: 16 }}>Situação do Cliente</Modal.Title>
      </Modal.Header>
      <Modal.Body className="text-center py-4">
        <p className="mb-1" style={{ fontSize: 14 }}>
          Tela de Situação em desenvolvimento — demanda separada.
        </p>
        {codigoConta && (
          <p className="text-muted" style={{ fontSize: 12 }}>
            Conta: {codigoConta} | GE: {codigoGrupoEmpresa}
          </p>
        )}
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" size="sm" onClick={onFechar}>Fechar</Button>
      </Modal.Footer>
    </Modal>
  );
};

export default ModalSituacaoClienteStub;
